
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 18","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.121 11.36l-1.512-.844a5.973 5.973 0 000-2.496l1.512-.844a.405.405 0 00.176-.492 8.987 8.987 0 00-1.899-3.34.426.426 0 00-.527-.07l-1.512.843a7.067 7.067 0 00-2.109-1.23V1.164a.41.41 0 00-.352-.387c-1.3-.316-2.601-.28-3.832 0-.21.035-.316.211-.316.387v1.723a6.296 6.296 0 00-2.145 1.265l-1.511-.879a.426.426 0 00-.528.07 8.988 8.988 0 00-1.898 3.34c-.07.176 0 .387.176.493l1.511.844a7.437 7.437 0 000 2.496l-1.511.843c-.176.106-.246.317-.176.493a8.988 8.988 0 001.898 3.34c.141.14.352.175.528.07l1.511-.844c.633.527 1.336.95 2.145 1.23v1.723c0 .176.14.352.316.422 1.301.281 2.602.246 3.832 0 .211-.07.352-.246.352-.422v-1.723a7.067 7.067 0 002.11-1.23l1.511.844c.176.105.387.07.527-.07.88-.95 1.512-2.075 1.934-3.34a.473.473 0 00-.21-.493zM9 12.062A2.777 2.777 0 016.187 9.25 2.798 2.798 0 019 6.437a2.82 2.82 0 012.813 2.813A2.798 2.798 0 019 12.063z"}})])
          )
        }
      }
    